/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../objects/classes/Composition.ts" />
/// <reference path="../objects/classes/Discount.ts" />
/// <reference path="../objects/classes/Address.ts" />
/// <reference path="../objects/interfaces/IDiscount.ts" />
/// <reference path="../objects/interfaces/ISessionService.ts" />
/// <reference path="../objects/interfaces/ISnackbarFactory.ts" />
/// <reference path="../services/composition.service.ts" />
/// <reference path="../factories/snackbar.factory.ts" />
/// <reference path="../objects/variables.ts" />

module App.Controllers {
    export interface IContactController extends IBaseController {

    }

    export class ContactController extends BaseController implements IContactController, Interfaces.IStepController {
        static controllerId = 'contactController';

        emailregex = Constants.regexExp.email;
        postcodeRegex = Constants.regexExp.postcode;
        showFormErrors: boolean = false;
        salutation: string = null;
        initials: string
        middleName: string
        lastName: string
        telephone: string
        email: string
        postcode: string
        houseNo: string
        street: string
        city: string
        discountCode: string
        remark: string
        defaultSalutation = Constants.defaultSalutation;

        showAddresLoader = false;
        showDiscountLoader = false;

        activeDiscounts: Interfaces.IDiscount[]
        discountError: boolean

        nextStepNumber: string
        prevStepNumber: string

        stepName: string = Constants.routeKeys.contact;

        recurringCustomer: boolean = false;

        privacy: boolean
        privacyStatement: string

        newsletter: boolean

        firstTimeDesc: string = "Wanneer uw auto eerder in onze werkplaats is geweest zijn uw gegevens bij ons bekend. Wanneer uw auto nog niet eerder in onze werkplaats is geweest hebben we aanvullende gegevens nodig.";
        personalDesc: string = "";
        discountDesc: string = "";

        hideActionCode: boolean = App.Variables.hideActionCode;
        allowCreateAccount: boolean = App.Variables.allowLogin;
        createAccount: boolean
        createAccountUsername: string
        createAccountPassword: string
        createAccountDesc: string = "Met je eigen ServiceOnly account kun je onder andere;<br/>- Gemakkelijk de historie van je auto('s) bekijken<br/>- Je kunt geadviseerde onderhoudswerkzaamheden in een oogopslag vinden<br/>- Gemakkelijk gepersonaliseerde werkplaatsafspraken maken<br/>- Je kunt gemakkelijk de lopende acties vinden";

        user = this.accountService.user;

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            SnackbarFactory.factoryId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId
        ];

        constructor($rootScope: Interfaces.IAppRootScope, $scope: any, $q: ng.IQService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            compositionService: Interfaces.ICompositionService,
            snackbarFactory: Interfaces.ISnackbarFactory,
            ngDialog: any,
            $sce: any,
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService) {
            super($rootScope, $scope, $q, sessionService, navigationService, compositionService, ngDialog, $sce, validationService, accountService, snackbarFactory)

            window.pageLoadDatalayerEvent(datalayerPageEvents.stap4)
            this.privacy = false
            this.privacyStatement = App.Variables.privacyStatement

            this.nextStepNumber = (sessionService.maxStepNumber - 1).toString()
            this.prevStepNumber = (sessionService.maxStepNumber - 2).toString()

            var composition = this.sessionService.composition
            if (typeof (composition) == undefined || composition == null) {
                return
            }

            if (typeof (composition.recurringCustomer) != undefined && composition.recurringCustomer != null) {
                this.recurringCustomer = composition.recurringCustomer || this.isAuthenticated()
            }
            else if (typeof (App.Variables.recurringCustomer) != undefined && App.Variables.recurringCustomer != null) {
                this.recurringCustomer = App.Variables.recurringCustomer || this.isAuthenticated()
            }
            else {
                this.recurringCustomer = false
            }

            if (this.user != null) {
                if (this.user.gender == 'Mannelijk')
                    this.salutation = 'Dhr.'
                if (this.user.gender == 'Vrouwelijk')
                    this.salutation = 'Mevr.'
                if (this.user.firstName != '')
                    this.initials = this.user.firstName
                if (this.user.middleName != '')
                    this.middleName = this.user.middleName
                if (this.user.lastName != '')
                    this.lastName = this.user.lastName
                if (this.user.phoneNumber != '')
                    this.telephone = this.user.phoneNumber
                if (this.user.email != '')
                    this.email = this.user.email
                if (this.user.address != null && this.user.address != '') {
                    var address = this.user.address.split(' ')
                    if (address.length > 1) {
                        this.houseNo = address.pop()
                        this.street = address.join(' ')
                    } else {
                        this.street = address[0]
                    }
                }
                if (this.user.city != '') {
                    this.city = this.user.city
                }
                if (this.user.zipcode != '') {
                    this.postcode = this.user.zipcode
                }
            }

            if (composition.address != null) {
                if (composition.address.salutation != null && composition.address.salutation != '' && composition.address.salutation != '-') {
                    this.salutation = composition.address.salutation
                }
                else if (App.Variables.gender == 'm') {
                    this.salutation = 'Dhr.'
                }
                else if (App.Variables.gender == 'v') {
                    this.salutation = 'Mevr.'
                }

                if (composition.address.firstName != null && composition.address.firstName != '') {
                    this.initials = composition.address.firstName
                }
                else if (App.Variables.firstName != '') {
                    this.initials = App.Variables.firstName
                }

                if (composition.address.middleName != null && composition.address.middleName != '') {
                    this.middleName = composition.address.middleName
                }
                else if (App.Variables.middleName != '') {
                    this.middleName = App.Variables.middleName
                }

                if (composition.address.lastName != null && composition.address.lastName != '') {
                    this.lastName = composition.address.lastName
                }
                else if (App.Variables.lastName != '') {
                    this.lastName = App.Variables.lastName
                }

                if (composition.address.phoneNumber != null && composition.address.phoneNumber != '') {
                    this.telephone = composition.address.phoneNumber
                }
                else if (App.Variables.phone != '') {
                    this.telephone = App.Variables.phone
                }

                if (composition.address.email != null && composition.address.email != '') {
                    this.email = composition.address.email
                }
                else if (App.Variables.email != '') {
                    this.email = App.Variables.email
                }

                if (composition.address.postalCode != null && composition.address.postalCode != '') {
                    this.postcode = composition.address.postalCode
                }

                if (composition.address.houseNumber != null && composition.address.houseNumber != '') {
                    this.houseNo = composition.address.houseNumber
                }

                if (composition.address.street != null && composition.address.street != '') {
                    this.street = composition.address.street
                }

                if (composition.address.city != null && composition.address.city != '') {
                    this.city = composition.address.city
                }
            } else {
                if (App.Variables.gender == 'm') {
                    this.salutation = 'Dhr.'
                }
                else if (App.Variables.gender == 'v') {
                    this.salutation = 'Mevr.'
                }
                if (App.Variables.firstName != '') {
                    this.initials = App.Variables.firstName
                }
                if (App.Variables.middleName != '') {
                    this.middleName = App.Variables.middleName
                }
                if (App.Variables.lastName != '') {
                    this.lastName = App.Variables.lastName
                }
                if (App.Variables.phone != '') {
                    this.telephone = App.Variables.phone
                }
                if (App.Variables.email != '') {
                    this.email = App.Variables.email
                }
                if (App.Variables.remark != '') {
                    this.remark = App.Variables.remark
                }
            }

            if (composition.selectedDiscountVoucher != null && composition.selectedDiscountVoucher != '')
            {
                this.discountCode = composition.selectedDiscountVoucher
            }
            else if (App.Variables.discountCode != '')
            {
                this.discountCode = App.Variables.discountCode
            }

            if (composition.remarks != null && composition.remarks != '')
            {
                this.remark = composition.remarks
            }

            this.scrollTop()
        }

        isAuthenticated = () => this.accountService.isAuthenticated;

        checkIfDiscountIsEmpty = () => {
            this.discountError = false // remove invalid notification when 
        }

        checkDiscountCode = () => {
            if (this.discountCode != null && this.discountCode != '') {
                this.showDiscountLoader = true

                var composition = this.sessionService.composition
                composition.privacyCheck = false
                composition.recurringCustomer = this.recurringCustomer || this.isAuthenticated()
                this.sessionService.composition = composition

                var currentActiveDiscountCodes = 0
                if (this.activeDiscounts != null) {
                    currentActiveDiscountCodes = this.activeDiscounts.length
                }

                this.setCompositionValue(Constants.apiServiceStateCalls.discountVoucher, this.discountCode, false).then(
                    (result: Classes.IComposition) => {
                        if (result.activeDiscounts != null) {
                            this.activeDiscounts = result.activeDiscounts
                            this.discountError = false

                            if (this.activeDiscounts.length <= currentActiveDiscountCodes) {
                                this.discountError = true
                            }
                        } else
                            this.discountError = true
                    }).catch((err) => {
                        console.log('error setCompositionValue discountCode: ' + JSON.stringify(err))
                    }).finally(() => {
                        this.showDiscountLoader = false
                    })
            } else {
                this.discountError = false
            }
        }

        isSalutationSelected = () => {
            return (this.salutation != null)
        }

        isValidPostCode = () => {
            return this.postcodeRegex.test(this.postcode)
        }

        postcodeChanged = () => {
            this.checkPageValidation()
            this.checkPostCodeAddress()
        }

        checkPostCodeAddress = () => {
            if (this.isValidPostCode() && this.houseNo != null) {
                this.showAddresLoader = true

                var composition = this.sessionService.composition
                composition.houseNumber = this.houseNo
                composition.postalCode = this.postcode
                composition.recurringCustomer = this.recurringCustomer || this.isAuthenticated()
                composition.privacyCheck = false
                this.sessionService.composition = composition

                this.setCompositionValue(Constants.apiServiceStateCalls.postalCode, this.postcode, false).then(
                    (result: Classes.IComposition) => {
                        this.street = result.address.street
                        this.city = result.address.city
                    }).catch((err) => {
                        console.log('error setCompositionValue postalCode: ' + JSON.stringify(err))
                    }).finally(() => {
                        this.showAddresLoader = false
                    })
            }
        }

        isValid(isLogicCheck: boolean = false): boolean {
            this.showFormErrors = !isLogicCheck

            if (this.$scope.contactForm.$valid && this.privacy == true) {

                if (this.createAccount) {
                    this.accountService.createAccount(
                        this.initials,
                        this.lastName,
                        this.sessionService.composition.licensePlate,
                        this.email)
                }

                var composition = this.sessionService.composition

                if (composition.address == null) {
                    composition.address = new Classes.Address()
                }

                composition.address.salutation = this.salutation
                composition.address.firstName = this.initials
                composition.address.middleName = this.middleName
                composition.address.lastName = this.lastName
                composition.address.phoneNumber = this.telephone
                composition.address.email = this.email
                composition.selectedDiscountVoucher = this.discountCode
                composition.remarks = this.remark
                composition.recurringCustomer = this.recurringCustomer || this.isAuthenticated()
                composition.newsletter = this.newsletter

                if (composition.address.street == null || composition.address.street == '') {
                    composition.address.street = this.street
                }

                if (composition.address.city == null || composition.address.city == '') {
                    composition.address.city = this.city
                }

                if (composition.address.houseNumber == null || composition.address.houseNumber == '') {
                    composition.address.houseNumber = this.houseNo
                }

                if (composition.address.postalCode == null || composition.address.postalCode == '') {
                    composition.address.postalCode = this.postcode
                }

                composition.postalCode = this.postcode
                composition.houseNumber = this.houseNo
                composition.privacyCheck = this.privacy
                composition.utmParams = App.Variables.utmParams

                this.sessionService.composition = composition

                let hasDiscountCode = false

                if (this.activeDiscounts && this.activeDiscounts.length > 0) {
                    hasDiscountCode = true
                }

                if (!isLogicCheck) {
                    window.sendContactDetailsToDatalayer(this.sessionService.composition.selectedProducts,
                        this.recurringCustomer,
                        this.email,
                        this.telephone,
                        this.initials,
                        this.lastName,
                        this.sessionService.composition.storeName,
                        this.sessionService.composition.waitForJob,
                        hasDiscountCode,
                        this.postcode,
                        window.getBrand(this.sessionService),
                        this.sessionService?.composition?.mileage,
                        this.activeDiscounts?.join(',')
                    )
                }

                return true
            } else {
                if (!isLogicCheck) {
                    this.snackbarFactory.show('Vul alle velden', 4000)
                }
                return false
            }
        }


        goBackToStep() {
            this.goToStep(Constants.routeKeys.appointment)
        }

        scrollTop = () => {
            window.scrollTo(0, 0)
        }
    }

    app.controller(ContactController.controllerId, ContactController)
}